// extracted by mini-css-extract-plugin
module.exports = {"noDataInfo":"noDataBanner_noDataInfo__3zBRD","noDataIcon":"noDataBanner_noDataIcon__1-n5h"};